import { RootState } from "../../store";
import {
  ICollectionYardsListRequest,
  ICollectionYardsVisit,
  ICollectionYardsVisitApi,
} from "../../types/collectionYards";
import { adaptFilterItemsForBe, adaptOrderingForBe } from "./adaptFiltersToBe";

export const adaptResponseForFronted = (apiVisits: ICollectionYardsVisitApi[]): ICollectionYardsVisit[] => {
  return apiVisits.map((apiVisit) => {
    return {
      visitId: apiVisit.collection_yard_visit_id,
      locationId: apiVisit.location_id,
      wasteTypes: apiVisit.waste_types,
      wasteSum: apiVisit.waste_sum,
      priceSum: apiVisit.price_sum,
      paidAt: apiVisit.paid_at,
      created: apiVisit.created,
      locationName: apiVisit.location_name,
      collectionYardName: apiVisit.collection_yard_name,
      wcpid: apiVisit.wcpid,
    };
  });
};

export const adaptRequestBodyForBackend = (
  state: RootState["collectionYards"],
  year: number,
  locationId?: number
): ICollectionYardsListRequest => {
  const { pagination, search, ordering, filters } = state;

  return {
    year,
    fulltext: search.fulltext,
    pagination,
    location_id: locationId,
    ordering: adaptOrderingForBe(ordering),
    filters: adaptFilterItemsForBe(filters.items),
  };
};
